/**
 * Loads third-party scripts after first interaction or when the browser is idle.
 * Falls back to a timeout so analytics still fire for bounce sessions.
 */
(function (window, document) {
  'use strict';

  var DEFAULT_TIMEOUT_MS = 3500;
  var loadedUrls = {};

  function injectScript(src, attrs) {
    if (!src || loadedUrls[src]) return;
    loadedUrls[src] = true;

    var script = document.createElement('script');
    script.src = src;
    script.async = true;

    if (attrs) {
      Object.keys(attrs).forEach(function (key) {
        if (attrs[key] != null) script.setAttribute(key, attrs[key]);
      });
    }

    document.head.appendChild(script);
  }

  function whenIdleOrInteractive(callback, timeoutMs) {
    var done = false;
    var timeout = timeoutMs == null ? DEFAULT_TIMEOUT_MS : timeoutMs;

    function run() {
      if (done) return;
      done = true;
      events.forEach(function (eventName) {
        window.removeEventListener(eventName, run, passiveOpts);
      });
      callback();
    }

    var events = ['scroll', 'pointerdown', 'touchstart', 'keydown'];
    var passiveOpts = { once: true, passive: true };
    events.forEach(function (eventName) {
      window.addEventListener(eventName, run, passiveOpts);
    });

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: timeout });
    } else {
      window.setTimeout(run, timeout);
    }
  }

  window.RoveDeferred = {
    injectScript: injectScript,
    whenIdleOrInteractive: whenIdleOrInteractive,
    load: function (src, attrs, timeoutMs) {
      whenIdleOrInteractive(function () {
        injectScript(src, attrs);
      }, timeoutMs);
    }
  };
})(window, document);
